import { render, staticRenderFns } from "./DictionaryDefaultTemplate.vue?vue&type=template&id=1ce7a25b&lang=pug&"
import script from "./DictionaryDefaultTemplate.vue?vue&type=script&lang=js&"
export * from "./DictionaryDefaultTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryDefaultTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports